import { render, staticRenderFns } from "./SecondaryNav.vue?vue&type=template&id=37f275fe"
import script from "./SecondaryNav.vue?vue&type=script&lang=js"
export * from "./SecondaryNav.vue?vue&type=script&lang=js"
import style0 from "./SecondaryNav.vue?vue&type=style&index=0&id=37f275fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports